import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="uvod" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-123">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/kz8rhY5ZFL3afPmoLdfTj6/IMG-20250203-WA0002.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-124" />

      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-neutral-950/80 via-neutral-900/60 to-neutral-950/90" data-id="element-125" />

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-127">
          <span className="inline-block py-1 px-3 rounded bg-[#e0a812]/20 text-[#e8b82e] text-xs sm:text-sm font-bold tracking-widest uppercase mb-6 border border-[#e0a812]/30" data-id="element-128">
            PRONÁJEM KOMERČNÍCH PROSTORŮ AŽ 7 500 M²
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6" data-id="element-129">
            Komerční areál <span className="text-[#e0a812]" data-id="element-130">Žlutice</span>
          </h1>
          <p className="mt-4 text-lg sm:text-xl md:text-2xl text-neutral-300 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-131">
            Haly, sklady, manipulační plochy a zázemí ve strategické lokalitě
            Karlovarského kraje. Od 10 000 Kč měsíčně.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-132">
            <a href="#o-objektu" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-[#e0a812] hover:bg-[#c4920f] transition-colors rounded-sm" data-id="element-133">
              Zjistit více
            </a>
            <a href="#kontakt" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-transparent border border-neutral-500 hover:border-white hover:bg-white/5 transition-all rounded-sm" data-id="element-134">
              Kontaktovat
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} data-id="element-135">
        <a href="#o-objektu" className="text-neutral-400 hover:text-white transition-colors" aria-label="Scroll down" data-id="element-136">
          <ChevronDownIcon className="w-8 h-8 opacity-70" data-id="element-137" />
        </a>
      </motion.div>
    </section>;
}